import { getPageContextFromWindow } from '@fandom/context';
import { interests } from './interestsData';
export function getInterestFromWikiId(wikiId) {
    return interests.find((interest) => interest.wikis.some((wiki) => wiki === wikiId));
}
export function getInterestForCurrentWiki() {
    return getInterestFromWikiId(getPageContextFromWindow().productId);
}
